import React from "react";
import "./popup.css";

const Popup = (props) => {
  return props.trigger ? (
    <div
      className={`popup ${
        props.trigger ? "popup--visible" : "popup--invisible"
      }`}
    >
      <div className="popup-inner">
        <button className="close-btn" onClick={() => props.setPopup(false)}>
          X
        </button>
        {props.children}
      </div>
    </div>
  ) : (
    ""
  );
};

export default Popup;
